import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { authHeaders, handleUnauthorized } from "@/lib/pin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailButton = ({ build, className = "btn btn-ghost", label = "Inviami per email" }) => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API}/email`, { method: "POST", headers: { "Content-Type": "application/json", ...authHeaders() }, body: JSON.stringify(build()) });
      handleUnauthorized(res);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || `Errore ${res.status}`);
      toast.success("Email inviata alla tua casella");
    } catch (e) {
      toast.error(`Email non inviata: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <button className={`${className} no-print`} onClick={send} disabled={busy} data-testid="email-send-btn">
      <Mail size={18} /> {busy ? "Invio…" : label}
    </button>
  );
};
